import { render, staticRenderFns } from "./practitioner.vue?vue&type=template&id=fe344094&scoped=true"
import script from "./practitioner.vue?vue&type=script&lang=js"
export * from "./practitioner.vue?vue&type=script&lang=js"
import style0 from "./practitioner.vue?vue&type=style&index=0&id=fe344094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe344094",
  null
  
)

export default component.exports